import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode } from 'react'

export interface CouponImageTagDefaultProps {
  titlePrefix: ReactNode
  titleSuffix: ReactNode
}
export const CouponImageTagDefault = (props: CouponImageTagDefaultProps) => {
  const { titlePrefix, titleSuffix } = props
  return (
    <Box px={1} py={1.5} height={36} color={colors.white} backgroundImage="linear-gradient(180deg, #FF7671 0%, #FF5353 100%)">
      <HStack alignItems="flex-end" justifyContent="center" gap={0.5} flexWrap="nowrap">
        <Text variant="subtitle" lineHeight="24px" fontSize="14px">{titlePrefix}</Text>
        <Text variant="h2" lineHeight="24px" fontSize="20px">{titleSuffix}</Text>
      </HStack>
    </Box>
  )
}
